import logoIcon from '../assets/mobile-app-icon--person-with-dark-blue-hair-in-thi.png';

export const BrainLogo = ({ size = 'md' }) => {
  const cls = size === 'lg'
    ? 'w-12 h-12 rounded-[14px] shadow-[0_4px_12px_rgba(168,218,220,0.25)]'
    : 'w-8 h-8 rounded-lg';
  return <img src={logoIcon} alt="LearnAtlas Logo" className={cls} />;
};
